module.exports = __webpack_public_path__ + "static/media/draumadeildin-logo-black.85142fb9.svg";